import { WidgetInstance } from "friendly-challenge";
import "jquery";

export default {
  init() {},
  finalize() {
    // Handle delivery address section visibility and required fields
    const $hasDeliveryAddressCheckbox = $("#has-delivery-address");
    const $deliveryAddressSection = $("#delivery-address-section");

    // Fields that should be required when delivery address is checked (all except switchboard)
    const requiredDeliveryFields = [
      "delivery-address",
      "delivery-postal",
      "delivery-city",
      "local-contact",
      "direct-line",
      "email-contact",
    ];

    // Function to toggle required attribute on delivery fields
    function toggleRequiredDeliveryFields(isRequired) {
      requiredDeliveryFields.forEach((fieldId) => {
        const $field = $("#" + fieldId);
        if ($field.length) {
          if (isRequired) {
            $field.prop("required", true);
            // Add required class to label
            $field.closest(".form-group").find("label").addClass("required");
          } else {
            $field.prop("required", false);
            // Remove required class from label
            $field.closest(".form-group").find("label").removeClass("required");
          }
        }
      });
    }

    // Function to toggle delivery address section visibility
    function toggleDeliveryAddressSection() {
      if ($hasDeliveryAddressCheckbox.is(":checked")) {
        $deliveryAddressSection.removeClass("d-none");
        toggleRequiredDeliveryFields(true);
      } else {
        $deliveryAddressSection.addClass("d-none");
        toggleRequiredDeliveryFields(false);
      }
    }

    // Initialize on page load
    if ($hasDeliveryAddressCheckbox.length && $deliveryAddressSection.length) {
      toggleDeliveryAddressSection();

      // Add event listener for checkbox change
      $hasDeliveryAddressCheckbox.on("change", toggleDeliveryAddressSection);
    }

    // Handle bank details section visibility and required fields
    const $paymentMethodRadios = $("input[name='payment-method']");
    const $bankDetailsSection = $("#bank-details");
    const $bicField = $("#bic");
    const $ibanField = $("#iban");

    function toggleBankDetailsSection() {
      const selectedPaymentMethod = $(
        "input[name='payment-method']:checked"
      ).val();

      // Only show bank details section for direct debit
      if (selectedPaymentMethod === "direct-debit") {
        $bankDetailsSection.removeClass("d-none");
        $bicField.prop("required", true);
        $ibanField.prop("required", true);
        $bicField.closest(".form-group").find("label").addClass("required");
        $ibanField.closest(".form-group").find("label").addClass("required");
      } else {
        $bankDetailsSection.addClass("d-none");
        $bicField.prop("required", false);
        $ibanField.prop("required", false);
        $bicField.closest(".form-group").find("label").removeClass("required");
        $ibanField.closest(".form-group").find("label").removeClass("required");
      }
    }

    // Initialize bank details section
    if ($paymentMethodRadios.length && $bankDetailsSection.length) {
      toggleBankDetailsSection();

      // Add event listeners to payment method radios
      $paymentMethodRadios.on("change", toggleBankDetailsSection);
    }

    // Handle PO number section visibility
    const $poRequiredRadios = $("input[name='po-required']");
    const $poNumberSection = $("#po-number-section");

    function togglePoNumberSection() {
      const isPoRequired =
        $("input[name='po-required']:checked").val() === "yes";
      const $poNumberField = $("#po-number");

      if (isPoRequired) {
        $poNumberSection.removeClass("d-none");
        // Add required attribute to PO number field
        $poNumberField.prop("required", true);
      } else {
        $poNumberSection.addClass("d-none");
        // Remove required attribute from PO number field
        $poNumberField.prop("required", false);
      }
    }

    // Initialize PO number section
    if ($poRequiredRadios.length && $poNumberSection.length) {
      togglePoNumberSection();

      // Add event listeners to PO required radios
      $poRequiredRadios.on("change", togglePoNumberSection);
    }

    // Handle invoice delivery method sections
    const $invoiceDeliveryMethods = $(".invoice-delivery-method");
    const $platformNameSection = $("#platform-name-section");
    const $otherMethodSection = $("#other-method-section");
    const $platformNameField = $("#invoice-delivery-platform-name");
    const $otherMethodField = $("#invoice-delivery-other-method");
    const $invoiceDeliveryError = $("#invoice-delivery-error");

    function toggleInvoiceDeliveryMethodSections() {
      // Check if platform checkbox is checked
      if ($("#invoice-platform").is(":checked")) {
        $platformNameSection.removeClass("d-none");
        $platformNameField.prop("required", true);
      } else {
        $platformNameSection.addClass("d-none");
        $platformNameField.prop("required", false);
        // Hide error message when section is hidden
        $("#invoice-delivery-platform-name-error").css("display", "none");
      }

      // Check if other checkbox is checked
      if ($("#invoice-other").is(":checked")) {
        $otherMethodSection.removeClass("d-none");
        $otherMethodField.prop("required", true);
      } else {
        $otherMethodSection.addClass("d-none");
        $otherMethodField.prop("required", false);
        // Hide error message when section is hidden
        $("#invoice-delivery-other-method-error").css("display", "none");
      }

      // Only trigger validation on the checkbox group to update its error display
      // but not on the newly shown fields
      const validator = $("#onboarding-form").data("validator");
      if (validator) {
        validator.element("input[name='invoice-delivery-method[]']");
      }
    }

    // Initialize invoice delivery method sections
    if ($invoiceDeliveryMethods.length) {
      toggleInvoiceDeliveryMethodSections();

      // Add event listeners to invoice delivery method checkboxes
      $invoiceDeliveryMethods.on("change", toggleInvoiceDeliveryMethodSections);
    }

    // FriendlyCaptcha setup
    const element = document.querySelector("#friendly-challenge");
    const options = {
      doneCallback: doneCallback,
      startMode: "none",
    };
    const widget = new WidgetInstance(element, options);
    let captchaResult = false;

    function doneCallback(solution) {
      captchaResult = true;
      $("#captcha-error").removeClass("d-block");
    }

    // Form validation
    $("#onboarding-form").validate({
      rules: {
        "primary-email": {
          required: true,
          email: true,
        },
        "technical-email": {
          required: true,
          email: true,
        },
        "owner-email": {
          required: true,
          email: true,
        },
        "email-contact": {
          email: true,
        },
        "accounting-email": {
          required: true,
          email: true,
        },
        "invoice-delivery-method[]": {
          required: true,
          minlength: 1,
        },
        "invoice-delivery-platform-name": {
          required: function () {
            return $("#invoice-platform").is(":checked");
          },
        },
        "invoice-delivery-other-method": {
          required: function () {
            return $("#invoice-other").is(":checked");
          },
        },
      },
      messages: {
        "invoice-delivery-method[]": {
          required:
            "Veuillez sélectionner au moins un mode d'envoi des factures",
          minlength:
            "Veuillez sélectionner au moins un mode d'envoi des factures",
        },
        "invoice-delivery-platform-name": {
          required: "Ce champ est obligatoire.",
        },
        "invoice-delivery-other-method": {
          required: "Ce champ est obligatoire.",
        },
      },
      errorElement: "div",
      errorClass: "invalid-feedback",
      errorPlacement: function (error, element) {
        // For invoice-delivery-platform-name, use the custom error element
        if (element.attr("id") === "invoice-delivery-platform-name") {
          error.replaceAll("#invoice-delivery-platform-name-error");
          return;
        }

        // For invoice-delivery-other-method, use the custom error element
        if (element.attr("id") === "invoice-delivery-other-method") {
          error.replaceAll("#invoice-delivery-other-method-error");
          return;
        }

        // For checkbox group, place error in the custom error div
        if (element.attr("name") === "invoice-delivery-method[]") {
          error.replaceAll("#invoice-delivery-error");
          return;
        }

        error.appendTo(element.closest(".form-group"));
      },
      highlight: function (element) {
        $(element).closest(".form-group").addClass("invalid");
        if (!captchaResult) {
          $("#captcha-error").addClass("d-block");
        }
      },
      unhighlight: function (element) {
        $(element).closest(".form-group").removeClass("invalid");
      },
      submitHandler: function (form) {
        // Mark the form as submitted for validation display
        $("#onboarding-form").data("submitted", true);

        if (!captchaResult) {
          $("#captcha-error").addClass("d-block");
        } else {
          submitForm();
        }
      },
    });

    function submitForm() {
      let $form = $("#onboarding-form");
      let $formData = new FormData($form.get(0));

      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: $formData,
        dataType: "JSON",
        processData: false,
        contentType: false,
        beforeSend: function () {
          $("#submit-onboarding-form")
            .addClass("processing")
            .prop("disabled", true);
        },
        complete: function (data) {
          setTimeout(function () {
            let timeOut = 0;
            if (
              (data.responseJSON && data.responseJSON.error) ||
              data.status !== 200
            ) {
              $("#submit-onboarding-form").addClass("fail");
              $(".alert-contact")
                .removeClass("alert-success")
                .addClass("alert-danger d-block")
                .empty()
                .append(data.responseJSON.error_message);
            } else {
              // Reset form
              $form.get(0).reset();

              // Reset sections visibility
              if ($deliveryAddressSection.length) {
                $deliveryAddressSection.addClass("d-none");
                toggleRequiredDeliveryFields(false);
              }

              if ($bankDetailsSection.length) {
                $bankDetailsSection.addClass("d-none");
              }

              if ($poNumberSection.length) {
                $poNumberSection.addClass("d-none");
              }

              // Reset invoice delivery method sections
              if ($platformNameSection.length) {
                $platformNameSection.addClass("d-none");
              }

              if ($otherMethodSection.length) {
                $otherMethodSection.addClass("d-none");
              }

              $("#submit-onboarding-form").addClass("success");
              $(".alert-contact")
                .removeClass("alert-danger")
                .addClass("alert-success d-block")
                .empty()
                .append("Nous avons bien reçu votre formulaire d'onboarding.");

              var offset =
                $(".alert-contact").offset().top - ($("header").height() + 48);

              // Scroll to the alert message
              $("html, body").animate(
                {
                  scrollTop: offset,
                },
                500
              );

              timeOut = 10000;
              setTimeout(function () {
                $(".alert-contact")
                  .removeClass("alert-success alert-danger d-block")
                  .addClass("d-none");
              }, timeOut);
            }
            setTimeout(function () {
              $("#submit-onboarding-form")
                .removeClass("processing success fail")
                .prop("disabled", false);
              captchaResult = false;
            }, timeOut);
            widget.reset();
          }, 500);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error("AJAX Error:", textStatus, errorThrown);
          $("#submit-onboarding-form").addClass("fail");
          $(".alert-contact")
            .removeClass("alert-success")
            .addClass("alert-danger d-block")
            .empty()
            .append("Une erreur est survenue lors de l'envoi du formulaire.");

          setTimeout(function () {
            $("#submit-onboarding-form")
              .removeClass("processing fail")
              .prop("disabled", false);
          }, 3000);
        },
      });
    }
  },
};
